<template>
  <div id="preview" :class="currentView">
    <div class="devices" v-if="showDeviceButtons">
      <button :class="['device-button', { active: currentView === 'lg' }]" @click="currentView = 'lg'">
        <i class="fas fa-desktop"></i>
      </button>
      <button :class="['device-button', { active: currentView === 'md' }]" @click="currentView = 'md'">
        <i class="fas fa-tablet-alt"></i>
      </button>
      <button :class="['device-button', { active: currentView === 'sm' }]" @click="currentView = 'sm'">
        <i class="fas fa-mobile-alt"></i>
      </button>
    </div>
    <iframe class="sections-container" ref="iframe"></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageCompiler from '@edools/page-compiler'
import browserHelper from '@/helpers/browserHelper'

export default {
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      currentView: 'lg',
      showDeviceButtons: true,
    }
  },
  computed: {
    ...mapGetters('landing', ['containers']),
  },
  mounted() {
    const { compiled } = PageCompiler.compile(this.$store.state.landing.landing)
    const iframe = this.$refs.iframe.contentWindow.document

    iframe.open()
    iframe.write(PageCompiler.build(compiled, this.$store.state.settings))
    iframe.close()

    const hB = browserHelper.getUrlParam('hide-buttons')
    if (hB) this.showDeviceButtons = hB.toLowerCase() !== 'true'
    document.querySelector('#app').style.backgroundColor = '#e0e0e0'
  },
}
</script>

<style lang="scss" scoped>
#preview {
  margin: 0 auto;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  &.sm {
    width: 375px;
  }
  &.md {
    width: 600px;
  }
  &.lg {
    width: 1356px;
    @media screen and (min-width: 1400px) {
      width: 100%;
    }
  }

  .sections-container {
    border: none;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .devices {
    position: absolute;
    display: flex;
    left: 4px;
    top: 4px;
    .device-button {
      margin: 0 4px;
      font-size: 26px;
      background: #262622;
      border-radius: 4px;
      border: none;
      color: white;
      outline: none;
      cursor: pointer;
      min-width: 24px;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      padding: 0 15px;
    }
  }
}
</style>
